/* Rewind - product cards swipe between the first two images on phones.

   The card's whole surface is a link (.card__heading a::after, z-index 1),
   and on a phone the image strip is lifted above it so the strip, not the
   overlay, receives the touch. That means a plain tap on the image no longer
   follows the link, so it is forwarded here. A pointer that moved more than a
   few pixels was a swipe, not a tap, and is left alone.

   Desktop is untouched: the strip is only a strip below 750px. */
(function () {
  if (window.__rwCardSwipe) return;
  window.__rwCardSwipe = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var downX = 0;
  var downY = 0;

  document.addEventListener(
    'pointerdown',
    function (event) {
      downX = event.clientX;
      downY = event.clientY;
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (!phone.matches || !event.target.closest) return;

    var strip = event.target.closest('.media--rw-swipe');
    if (!strip) return;

    /* Only the strips that really are strips - a card with one product photo
       is left as Dawn built it, its link overlay still on top, and forwarding
       the tap here would fire the link twice. */
    if (strip.scrollWidth <= strip.clientWidth) return;

    if (Math.abs(event.clientX - downX) > 10) return;
    if (Math.abs(event.clientY - downY) > 10) return;

    var wrapper = strip.closest('.card-wrapper');
    var link = wrapper && wrapper.querySelector('a.full-unstyled-link');
    if (link) link.click();
  });
})();
